module.exports = __webpack_public_path__ + "static/media/PCP Inactive Ingredient or Allergen.94a64c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/PCP Inactive Ingredient or Allergen.png
// module id = 1189
// module chunks = 0